export default __webpack_public_path__ + "static/shawn1-8faa18fe3b8e9cc9db6ba4b0cf3d3223.png";